'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage from "./io.intela.sites.digitalinternship.-Page.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$CaseStudy(slug) {
  this.fr = null;
  this.fr = slug;
}
export { $c_Lio_intela_sites_digitalinternship_Page$CaseStudy as $c_Lio_intela_sites_digitalinternship_Page$CaseStudy };
$p = $c_Lio_intela_sites_digitalinternship_Page$CaseStudy.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage.$h_Lio_intela_sites_digitalinternship_Page();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$CaseStudy;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$CaseStudy() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$CaseStudy as $h_Lio_intela_sites_digitalinternship_Page$CaseStudy };
$h_Lio_intela_sites_digitalinternship_Page$CaseStudy.prototype = $p;
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1771096329), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_Page$CaseStudy) && (this.fr === x$0.fr)));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "CaseStudy";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fr;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_Page$CaseStudy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bn)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_Page$CaseStudy as $isArrayOf_Lio_intela_sites_digitalinternship_Page$CaseStudy };
var $d_Lio_intela_sites_digitalinternship_Page$CaseStudy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_Page$CaseStudy, "io.intela.sites.digitalinternship.Page$CaseStudy", ({
  bn: 1,
  av: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$CaseStudy as $d_Lio_intela_sites_digitalinternship_Page$CaseStudy };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$-Case-Study.js.map
